import { render, staticRenderFns } from "./WF8_UnscubscribeThanks.vue?vue&type=template&id=332ff370"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports